<template>
  <div :id="id" class="pie-box" :style="`background-image:url(${centerImg})`" />
</template>
<script>
import * as echarts from "echarts";
import resize from "@/utils/resize";
export default {
  mixins: [resize],
  props: {
    color: {
      type: Array,
      default: () => ["#006fa5", "#a5eefc"],
    },
    id: {
      type: String,
      default: "simplePie",
    },
    subtext: {
      type: String,
      default: "起",
    },
    centerImg: {
      type: String,
      default: "",
    },
    arr: {
      type: Array,
      default: () => [
        {
          name: "环境温度",
          value: 150,
          bfb: "35%",
        },
        {
          name: "环境湿度",
          value: 150,
          bfb: "20%",
        },
      ],
    },
  },
  data() {
    return {
      chart: null,
      allnum: 0,
    };
  },
  mounted() {
    this.renderChart();
  },
  methods: {
    renderChart() {
      this.chart = echarts.init(document.getElementById(this.id));

      let tempData = this.arr.map((val, index) => {
        this.allnum += parseInt(val.value);
        return {
          ...val,
          itemStyle: {
            normal: {
              color:
                index === 0
                  ? "rgb(52, 70, 98)"
                  : new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                      {
                        offset: 0,
                        color: this.color[0],
                      },
                      {
                        offset: 1,
                        color: this.color[1],
                      },
                    ]),
            },
          },
        };
      });
      const option = {
        animation: true,
        title: {
          show: false,
          text: this.allnum,
          subtext: this.subtext,
          x: "center",
          y: "34%",
          textStyle: {
            color: "#fff",
            fontSize: 20,
            fontWeight: "600",
            align: "center",
            // "width": "200px"
          },
          subtextStyle: {
            color: "rgba(#fff, 0.6)",
            fontSize: 10,
            fontWeight: "normal",
          },
        },

        series: [
          {
            type: "pie",
            center: ["50%", "50%"],
            radius: ["55%", "78%"],
            startAngle: 90,
            labelLine: {
              normal: {
                length: 25,
              },
            },
            label: {
              normal: {
                show: false,
              },
            },
            data: tempData,
          },
        ],
      };
      this.chart.setOption(option);
    },
  },
};
</script>
<style scoped lang="scss">
.pie-box {
  position: absolute;
  right: calc(-100vw / 1920 * 20);
  top: 50%;
  margin-top: calc(-100vw / 1920 * 75);
  width: calc(100vw / 1920 * 150);
  height: calc(100vw / 1920 * 150);
  border-radius: 50%;
  border: calc(100vw / 1920 * 5) solid rgba(4, 30, 72, 1);
  background-color: rgba(4, 30, 72, 1);
  background-size: 30%;
  background-repeat: no-repeat;
  background-position: center;
}
</style>
